// Item (b), batch 3: the automatic follow-up emails going out in the next few working days.

// No "Contact logged: it will be paused" note any more: decision 3 (14/10), a logged call or note never pauses or
// stops the emails.

/** The rows a filter by salesperson leaves (null = everyone). */
export function bySalesperson(rows, salespersonId) {
  if (salespersonId === null || salespersonId === undefined) return rows || []
  return (rows || []).filter(r => r.salespersonId === salespersonId)
}

/** The salespeople in the list, for the filter, by name. */
export function salespeople(rows) {
  var seen = {}
  ;(rows || []).forEach(r => { if (r.salespersonId !== null && r.salespersonId !== undefined) seen[r.salespersonId] = r.salespersonName || ('User ' + r.salespersonId) })
  return Object.keys(seen).map(id => ({ id: Number(id), name: seen[id] })).sort((a, b) => a.name.localeCompare(b.name))
}

/** The page's explanation line. */
export function headline(data) {
  if (!data) return ''
  if (!data.enabled) return 'Follow-up emails are switched off, so none are going out.'
  return 'Automatic follow-up emails due in the next ' + data.workingDays + ' working days (to ' + data.until + '). ' +
    'Untick an email to skip it; the quote\'s later emails still go.'
}

// ---- The Follow up page's list (Mohammed 04/10/2026): Global Search, header filters, sorting ----

const DAY_TIME = /^(\d{2})\/(\d{2})\/(\d{4})(?:\s+(\d{2}):(\d{2}))?/

/** "06/10/2026 10:00" -> "202610061000", so the Due column sorts by date, not as text. '' when unreadable. */
export function dueSortKey(dueAt) {
  var m = DAY_TIME.exec(String(dueAt || ''))
  return m ? m[3] + m[2] + m[1] + (m[4] || '00') + (m[5] || '00') : ''
}

const dayKey = d => (d instanceof Date && !isNaN(d.getTime())
  ? String(d.getFullYear()) + String(d.getMonth() + 1).padStart(2, '0') + String(d.getDate()).padStart(2, '0') : null)

const has = (value, text) => String(value || '').toLowerCase().indexOf(text) >= 0

/** The text Global Search looks through on one row. */
function searchable(row) {
  return [row.quoteRef, row.customerName, row.contactName, row.contactEmail, row.subject,
    'Email ' + row.stepNo, row.salespersonName, row.dueAt, row.skipRequestedBy].join(' \u0001 ')
}

/**
 * The rows the header filters and Global Search leave. `f` is
 * `{ search, from, to (Dates, both days included), quote, customer, contact, salespersonId }`; empty means no filter.
 */
export function filterGoingOut(rows, f) {
  var o = f || {}
  var search = String(o.search || '').trim().toLowerCase()
  var quote = String(o.quote || '').trim().toLowerCase()
  var customer = String(o.customer || '').trim().toLowerCase()
  var contact = String(o.contact || '').trim().toLowerCase()
  var from = dayKey(o.from)
  var to = dayKey(o.to)
  return bySalesperson(rows, o.salespersonId).filter(r => {
    var day = dueSortKey(r.dueAt).slice(0, 8)
    if (from && (!day || day < from)) return false
    if (to && (!day || day > to)) return false
    if (quote && !has(r.quoteRef, quote)) return false
    if (customer && !has(r.customerName, customer)) return false
    if (contact && !has(r.contactName, contact) && !has(r.contactEmail, contact)) return false
    if (search && !has(searchable(r), search)) return false
    return true
  })
}
